import {
  DeviceCharacteristicGroupDetailType,
  DeviceDetailInterface
} from 'features/eai/eaiTypes';

// ==============================|| UTILS ||============================== //

export const mergeDeviceDetails = (
  originalDevices: DeviceDetailInterface[],
  newDevices: DeviceDetailInterface[]
): DeviceDetailInterface[] => {
  const mergedDevices = [...originalDevices];
  const newDevicesMap = new Map();

  for (const device of newDevices) {
    newDevicesMap.set(device.deviceId, device);
  }

  for (let i = 0; i < mergedDevices.length; i++) {
    const existingDevice = newDevicesMap.get(mergedDevices[i].deviceId);
    if (existingDevice) {
      mergedDevices[i] = existingDevice;
      newDevicesMap.delete(mergedDevices[i].deviceId);
    }
  }

  for (const device of newDevicesMap.values()) {
    mergedDevices.push(device);
  }

  return mergedDevices;
};

export const mergeDeviceCharacteristicGroupDetails = (
  originalGroups: DeviceCharacteristicGroupDetailType[],
  newGroups: DeviceCharacteristicGroupDetailType[]
): DeviceCharacteristicGroupDetailType[] => {
  const mergedGroups = [...originalGroups];
  const newGroupsMap = new Map();

  for (const group of newGroups) {
    newGroupsMap.set(group.deviceCharacteristicGroupId, group);
  }

  for (let i = 0; i < mergedGroups.length; i++) {
    const existingGroup = newGroupsMap.get(
      mergedGroups[i].deviceCharacteristicGroupId
    );
    if (existingGroup) {
      mergedGroups[i] = existingGroup;
      newGroupsMap.delete(mergedGroups[i].deviceCharacteristicGroupId);
    }
  }

  for (const group of newGroupsMap.values()) {
    mergedGroups.push(group);
  }

  return mergedGroups;
};
